// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@hardwoods/XDL/Utilities";
import { IconPresentationProps } from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface NotifyStyles {
    container?: InjectableCss;
    notifyIcon?: IconPresentationProps;
    closeIcon?: IconPresentationProps;
}

const notifyStyles: NotifyStyles = {
    container: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            margin: 12px 12px 12px 0;
            flex-grow: 1;
        `,
    },
    notifyIcon: {
        size: 18,
    },
    closeIcon: {
        size: 10,
        color: "text.main",
        css: css`
            margin: 15px;
            &:hover {
                color: ${color("danger")};
            }
        `,
    },
};

export default notifyStyles;
